module.exports = __webpack_public_path__ + "img/faceBg.cc3432db.png";